import { Roles } from "app/models/user"
import { Action, Types } from "./roles.actions"

export type RolesState = {
  data: Roles[] | undefined
  errors: {}
  loading: boolean
}

const initialState: RolesState = {
  data: undefined,
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): RolesState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
